export const linkToBrandsPage = (locale) => {
    return `/${locale}/brands`;
};